import { html, nothing } from 'lit';
import { t } from 'i18next';
import { formatDate } from '../../../utils/date';
export const Reply = ({ reply, isReplierSeller, feedbackGiven }) => {
    if (!reply)
        return nothing;
    const role = !feedbackGiven ? t('You') : isReplierSeller ? t('Seller') : t('Buyer');
    return html `
    <div
      class="p-16 rounded-16 bg-marble w-full"
    >
      <p class="caption strong">
        ${t('{{role}} responded', { role })} ${formatDate(reply.givenAt)}
      </p>
      <p class="mt-8 caption">${reply.text}</p>
    </div>
  `;
};
//# sourceMappingURL=Reply.js.map